import React from 'react';
import './DownloadSection.css';

const DownloadSection = () => {
  return (
    <section className="sp-dl-wrapper motion-section">
      {/* Background Floating Decorative Glows */}
      <div className="sp-dl-glow sp-dl-glow-purple"></div>
      <div className="sp-dl-glow sp-dl-glow-cyan"></div>

      <div className="sp-dl-container">
        {/* LEFT CONTENT AREA */}
        <div className="sp-dl-content">
          <div className="sp-dl-pill">
            <span className="sp-dl-sparkle">✨</span> Get The App Now
          </div>
          <h2 className="sp-dl-title">
            Download <span className="sp-dl-brand-gradient">ATZ Pay</span>
          </h2>
          <p className="sp-dl-description">
            One wallet for payments, digital assets, and total control wherever you go.
          </p>
        </div>

        {/* RIGHT ACTION BUTTONS & QR CODE */}
        <div className="sp-dl-actions-group">
          <div className="sp-dl-buttons-col">
            {/* Google Play Store Button */}
            <a 
              href="https://play.google.com" 
              target="_blank" 
              rel="noreferrer" 
              className="sp-dl-store-btn sp-dl-btn-play"
            >
              <svg className="sp-dl-btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L18.81,13.96C19.46,13.58 19.46,12.42 18.81,12.04L16.81,10.88L14.75,12.94L16.81,15.12M4.6,2.83L14.04,12.27L11.97,14.34L4.6,2.83M4.6,21.17L11.97,13.8L14.04,15.87L4.6,21.17Z" />
              </svg>
              <div className="sp-dl-btn-text">
                <span className="sp-dl-btn-label">GET IT ON</span>
                <span className="sp-dl-btn-store-name">Google Play</span>
              </div>
            </a>

            {/* Apple App Store Button */}
            <a 
              href="https://apple.com/app-store" 
              target="_blank" 
              rel="noreferrer" 
              className="sp-dl-store-btn sp-dl-btn-apple"
            >
              <svg className="sp-dl-btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.6 14.23,1.35 14.09,0.1C12.96,0.15 11.58,0.86 10.77,1.81C10.05,2.65 9.53,3.93 9.7,5.15C10.96,5.25 12.27,4.4 13,3.5Z" />
              </svg>
              <div className="sp-dl-btn-text">
                <span className="sp-dl-btn-label">Download on the</span>
                <span className="sp-dl-btn-store-name">App Store</span>
              </div>
            </a>
          </div>

          {/* Interactive Animated QR Code Box */}
          <div className="sp-dl-qr-card">
            <div className="sp-dl-qr-border-glow"></div>
            <div className="sp-dl-qr-inner">
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://atzpay.com/download"
                alt="Scan to Download ATZ Pay App"
                className="sp-dl-qr-img"
              />
              <span className="sp-dl-qr-scan-line"></span>
            </div>
            <p className="sp-dl-qr-hint">Scan to Download</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;